
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/CrazysalesWarrantyPolicy",
      function () {
        return require("private-next-pages/article/CrazysalesWarrantyPolicy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/CrazysalesWarrantyPolicy"])
      });
    }
  